import http from '@/utils/http'

const URL = '/rest/customer/shop/customer-score'
const AWARD_URL = '/rest/customer/shop/customer-score-tasks'
const SIGN_URL = '/rest/customer/shop/sign-in'
const TASKS_URL = '/rest/customer/shop/customer-score-tasks/list'

export default {
  scoreList (cb) {
    http.get(URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  signList (cb) {
    http.get(SIGN_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  awardList (cb) {
    http.get(AWARD_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  signIn (cb) {
    http.post(SIGN_URL, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  taskList (cb) {
    http.get(TASKS_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/task-wall.js